/* eslint-disable react-hooks/exhaustive-deps */
import React, { FC, useCallback, useEffect, useRef, useState } from 'react';
import { Box } from '@mui/material';

interface CustomInfiniteScrollListProps {
    list: Array<any>;
    title?: any;
    gap?: number;
    styles?: object;
    disableWrap?: boolean;
    horizontal?: boolean;
}

const DEFAULT_GAP = 0;
const INCREMENT_AMOUNT = 18;

const CustomInfiniteScrollList: FC<CustomInfiniteScrollListProps> = ({
    list,
    title,
    gap,
    styles,
    disableWrap,
    horizontal,
}) => {
    const [displayedAmount, setDisplayedAmount] = useState(INCREMENT_AMOUNT * 3);
    const containerRef = useRef(null);

    const showMoreItems = useCallback(() => {
        const incrementQuery = horizontal
            ? containerRef.current.scrollLeft + containerRef.current.offsetWidth >=
              containerRef.current.scrollWidth - 100
            : containerRef.current.scrollTop + containerRef.current.offsetHeight >=
              containerRef.current.scrollHeight - 100;
        if (incrementQuery) {
            setDisplayedAmount((currentAmount) => currentAmount + INCREMENT_AMOUNT);
        }
    }, [displayedAmount]);

    useEffect(() => {
        if (displayedAmount >= list.length) {
            containerRef.current?.removeEventListener('scroll', showMoreItems);
        } else {
            containerRef.current?.addEventListener('scroll', showMoreItems);
        }
        return () => {
            containerRef.current?.removeEventListener('scroll', showMoreItems);
        };
    }, [showMoreItems, displayedAmount, containerRef.current]);

    return (
        <Box sx={{ height: '100%', overflow: list.length > displayedAmount ? 'scroll' : 'auto' }} ref={containerRef}>
            {title}
            <Box
                sx={{
                    display: 'flex',
                    flexWrap: disableWrap ? 'unset' : 'wrap',
                    rowGap: gap || DEFAULT_GAP,
                    columnGap: gap || DEFAULT_GAP,
                    ...styles,
                }}
            >
                {list.slice(0, displayedAmount)}
            </Box>
        </Box>
    );
};

export default CustomInfiniteScrollList;
